export const presetWindowLabelMapper = new Map([
  ['FULL_DAY', 'fullDay'],
  ['HALF_DAY_1', 'allMorning'],
  ['HALF_DAY_2', 'allAfternoon'],
]);
